import React from 'react'
import { Wrapper } from './LeaderBoardEntity.styled';
import { Row , Col , Button} from  "components/common";
import SampleImage from "../../../../assets/images/testerimagesample.jpg";




const LeaderBoard =({data})=> {
return (
    <Wrapper>
   <Row gutter={[10, 10]} className="rank-section">
            <Col className="rank-title" xs={6} sm={5} md={5} lg={6}>
              <div className="ranker-image">
                <span>{data?.ranking}</span>
                <img src={SampleImage} alt="" />
              </div>
            </Col>
            <Col className="rank-title" xs={8} sm={9} md={9} lg={8}>
              <div className="ranker-info">
                <h5>{data?.name}</h5>
                <span>{data?.city}</span>
              </div>
            </Col>
            <Col className="rank-title" xs={5} sm={5} md={5} lg={5}>
              <span>{data?.power} </span>
            </Col>
            <Col className="rank-title" xs={5} sm={5} md={5} lg={5}>
              <span>{data?.sales}</span>
            </Col>
          </Row>
    </Wrapper>
)};








export default LeaderBoard;